import React from 'react'
import { EmptyScreenStyles } from './Style'
import { Img } from 'styles/GlobalStyle'
import { EmptyNormalator } from 'assets'

const EmptyScreen = () => {

    return (
        <EmptyScreenStyles>
            <div className='empty-screen-title'>
                {"צריך לבחור סוג מבדק, תחום בדיקה ושיטה רוצים לראות במסננים למעלה וללחוץ על הצג"}
            </div>
            <div className='empty-screen-sub-title'>
                <div>{"לאחר בחירת מבדק ובדיקה"}</div>
                <div>{"יוצג הנורמלטור."}</div>
            </div>
            <div>
                <div className='empty-normalator'>
                    <div className='empty-normalator-img'>
                        <Img src={EmptyNormalator} />
                    </div>
                </div>
            </div>
        </EmptyScreenStyles>
    )
}

export default EmptyScreen